export default "__VITE_ASSET__e7ba667b__"